import React, { useState } from "react";
import {
  FaBitcoin,
  FaCalendarAlt,
  FaDiscord,
  FaDownload,
  FaFacebookF,
  FaGlobe,
  FaHome,
  FaInstagram,
  FaMediumM,
  FaRedditAlien,
  FaRegEye,
  FaRegFileAlt,
  FaSearch,
  FaTelegramPlane,
  FaTwitter,
  FaUserAlt,
  FaYoutube,
} from "react-icons/fa";
import {
  MdArrowBack,
  MdArrowForward,
  MdClose,
  MdHeadsetMic,
  MdInfo,
  MdLock,
  MdMoreVert,
  MdRefresh,
  MdStarBorder,
} from "react-icons/md";
import { TiArrowSortedDown } from "react-icons/ti";

import { RiArrowDownSLine, RiUserSettingsLine } from "react-icons/ri";
import "./App.css";
import profile from "./images/profile.svg";
import menu from "./images/menu.svg";
import roundprofile from "./images/roundprofile.svg";
import world from "./images/world.svg";
import btc from "./images/btc.svg";
import poolpic from "./images/poolpic.png";

const footerGroups = [
  {
    title: "Community",
    social: true,
    links: [
      { label: "Discord", icon: FaDiscord },
      { label: "Telegram", icon: FaTelegramPlane },
      { label: "Facebook", icon: FaFacebookF },
      { label: "Twitter", icon: FaTwitter },
      { label: "Reddit", icon: FaRedditAlien },
      { label: "Instagram", icon: FaInstagram },
      { label: "Medium", icon: FaMediumM },
      { label: "YouTube", icon: FaYoutube },
    ],
  },
  {
    title: "About",
    links: [
      "About",
      "Press",
      "Careers",
      "Business Contacts",
      "Community",
      "Binance Blog",
      "Building Trust",
      "Legal",
      "Terms",
    ],
  },
  {
    title: "Products",
    links: [
      "Exchange",
      "Academy",
      "Binance Live",
      "Charity",
      "Card",
      "Labs",
      "Launchpad",
      "Research",
      "Trust Wallet",
    ],
  },
  {
    title: "Service",
    links: [
      "Downloads",
      "Buy Crypto",
      "Institutional & VIP Services",
      "OTC Trading",
      "Referral",
      "BNB",
      "Listing Application",
      "P2P Merchant Application",
    ],
  },
  {
    title: "Support",
    links: [
      "Request a Feature",
      "Support Center",
      "24/7 Chat Support",
      "APIs",
      "Fees",
      "Trading Rules",
      "Binance Verify",
      "Law Enforcement Requests",
    ],
  },
  {
    title: "Learn",
    links: [
      "Learn & Earn",
      "Browse Crypto Prices",
      "Bitcoin Price",
      "Ethereum Price",
      "Buy BNB",
      "Buy Bitcoin",
      "Buy Ethereum",
      "Buy Dogecoin",
    ],
  },
];

const navItems = [
  "Home",
  "Mining Pool",
  "Pool Savings",
  "Cloud Mining",
  "More",
];
const tabs = [
  "Statistics",
  "Workers",
  "Earnings",
  "Account Overview",
  "Settings",
];
const tableHeadings = [
  "mining date",
  "Daily Hashrate",
  "Type",
  "Network Difficulty",
  "Earnings",
  "Status",
];

function BinanceLogo() {
  return (
    <div className="pool-logo" aria-label="Binance Pool">
      <div className="pool-mark">
        <span />
        <span />
        <span />
        <span />
      </div>
      <div>
        <div>BINANCE</div>
        <strong>POOL</strong>
      </div>
    </div>
  );
}

function IconButton({ children, label }) {
  return (
    <button className="icon-button" aria-label={label} title={label}>
      {children}
    </button>
  );
}

function BrowserChrome() {
  return (
    <div className="browser-chrome">
      <div className="browser-tabs">
        <div className="traffic">
          <span className="red" />
          <span className="yellow" />
          <span className="green" />
        </div>
        <div className="tab">
          <span className="tiny-logo">
            <FaBitcoin />
          </span>
          <span>Bitcoin Mining Pool | Bitcoin ...</span>
          <MdClose className="tab-close" />
        </div>
        <span className="new-tab">+</span>
      </div>
      <div className="browser-address">
        <MdArrowBack />
        <MdArrowForward />
        <MdRefresh className="reload" />
        <div className="address-pill">
          <span className="lock-dot">
            <MdLock />
          </span>
          pool.binance.com/en/earnings
        </div>
        <MdStarBorder className="star" />
        <span className="profile-dot">
          <MdInfo />
        </span>
        <MdMoreVert className="menu-dot" />
      </div>
    </div>
  );
}

function EditPanel({ values, onChange, onHide }) {
  return (
    <aside className="edit-panel">
      <div className="edit-panel-head">
        <div>
          <strong>Edit receipt</strong>
          <span>Live values</span>
        </div>
        <button type="button" onClick={onHide}>
          Hide
        </button>
      </div>

      <label>
        Name
        <input
          value={values.name}
          onChange={(event) => onChange("name", event.target.value)}
        />
      </label>
      <label>
        Accumulated Earnings
        <input
          value={values.accumulatedEarnings}
          onChange={(event) => onChange("accumulatedEarnings", event.target.value)}
        />
      </label>
      <label>
        BTC Balance
        <input
          value={values.btcBalance}
          onChange={(event) => onChange("btcBalance", event.target.value)}
        />
      </label>
      <label>
        Date
        <input
          value={values.date}
          onChange={(event) => onChange("date", event.target.value)}
        />
      </label>
      <label>
        Time
        <input
          value={values.time}
          onChange={(event) => onChange("time", event.target.value)}
        />
      </label>
      <label>
        Width
        <div className="width-input-row">
          <input
            type="range"
            min="40"
            max="100"
            value={values.width}
            onChange={(event) => onChange("width", event.target.value)}
          />
          <input
            type="number"
            min="40"
            max="100"
            value={values.width}
            onChange={(event) => onChange("width", event.target.value)}
          />
        </div>
      </label>
      <label>
        Bigger text
        <div className="width-input-row">
          <label className="toggle-control">
            <input
              type="checkbox"
              checked={values.textScaleEnabled}
              onChange={(event) => onChange("textScaleEnabled", event.target.checked)}
            />
            <span>Enable 20–30% larger text</span>
          </label>
          <input
            type="range"
            min="120"
            max="130"
            value={values.textScale}
            disabled={!values.textScaleEnabled}
            onChange={(event) => onChange("textScale", event.target.value)}
          />
          <input
            type="number"
            min="120"
            max="130"
            value={values.textScale}
            disabled={!values.textScaleEnabled}
            onChange={(event) => onChange("textScale", event.target.value)}
          />
        </div>
      </label>
    </aside>
  );
}

function App() {
  const [showEditor, setShowEditor] = useState(true);
  const [values, setValues] = useState({
    name: "JohnSchneider",
    accumulatedEarnings: "0.00000000",
    btcBalance: "0.00000000",
    date: "YYYY-MM-DD -> YYYY-MM-DD",
    time: "02:00-10:00 UTC",
    width: 100,
    textScaleEnabled: false,
    textScale: 120,
  });

  const updateValue = (key, value) => {
    const parsedValue = key === "width" || key === "textScale" ? Number(value) : value;
    setValues((current) => ({
      ...current,
      [key]: parsedValue,
    }));
  };

  return (
    <div
      className="app-shell"
      style={{
        transformOrigin: "top left",
        transform: values.textScaleEnabled ? `scale(${values.textScale / 100})` : "scale(1)",
      }}
    >
      {/* <BrowserChrome /> */}

      <div className="pool-page">
        <header className="site-header">
          <div className="header-left">
            <IconButton label="Home">
              <FaHome className="nav-icon" />
            </IconButton>
            <BinanceLogo />
            <nav className="top-nav">
              {navItems.map((item) => (
                <a
                  href="#top"
                  key={item}
                  className={item === "Mining Pool" ? "active" : ""}
                >
                  {item}
                  {(item === "Mining Pool" || item === "More") && (
                    <RiArrowDownSLine className="chevron" />
                  )}
                </a>
              ))}
            </nav>
          </div>

          <div className="header-actions">
            <IconButton label="Account">
              <img
                src={roundprofile}
                alt="roundprofile"
                className="roundprofile-pic"
              />
            </IconButton>
            <IconButton label="Language">
              <img src={world} alt="world" className="world-pic" />
            </IconButton>

            <IconButton label="menu">
              <img src={menu} alt="menu" className="menu-pic" />
            </IconButton>
          </div>
        </header>
        <div className="w-full !h-24 bg-red-500">
          <img src={poolpic} alt="btc" className="pool-pic max-h-24 w-full" />
        </div>

        <main style={{ width: `${values.width}%` }} className="content-area px-2" id="top">
          <section className="tabs-row">
            <div className="pool-tabs">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={tab === "Earnings" ? "active" : ""}
                  type="button"
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className="selector-row">
              <button
                style={{ paddding: "10px" }}
                className="coin-select "
                type="button"
              >
                <span className="btc-dot">
                  {/* <FaBitcoin /> */}
                  <img src={btc} alt="btc" className="btc-pic" />
                </span>
                BTC
                <TiArrowSortedDown className="small-caret bold" />
              </button>
              <button className="account-select" type="button">
                <img src={profile} alt="Profile" className="profile-pic" />
                {values.name}
                <TiArrowSortedDown className="small-caret bold" />
              </button>
            </div>
          </section>

          <section className="earnings-layout  flex justify-between items-center flex-row w-full">
            <div className="earnings-copy mr-8">
              <h1>Earnings History for {values.name}</h1>
              <div className="subtabs">
                <button className="active" type="button">
                  Mining Earnings
                </button>
                <button type="button">Extra Bonus</button>
              </div>
              <p>
                Daily settlements are calculated at UTC time, with payouts
                issued the following day between {values.time}.
              </p>
            </div>
<div className="flex  flex-row justify-start items-end  ml-8">   
  <div className="earnings-summary mr-4">
            
              <span className="summary-label text-base">Accumulated Earnings</span>
              <p className="text-2xl ">${values.accumulatedEarnings}</p>
              <div className="summary-actions  ">
                <button className="date-button" type="button">
                  {values.date}
                  <FaCalendarAlt />
                </button>
                <button className="download-button" type="button">
                  <FaDownload />
                  Download
                </button>
              </div>
            </div>
                 <div className="earnings-summary mb-6 pb-1">
              <div className="summary-title   ">
                <span className="text-yellow-500 border rounded-md px-2 bg-yellow-100">Balance </span>
                
                <FaRegEye />
                <FaRegFileAlt />
              </div>
   
              <p className="flex justify-center items-center"><span className="text-2xl mb-1">{values.btcBalance}</span><span className="text-gray-500 text-sm font-bold"> BTC</span></p>
         
            </div>
            </div>
         
          </section>

          <section className="table-wrap">
            <div className="table-head">
              {tableHeadings.map((heading) => (
                <span key={heading}>{heading}</span>
              ))}
            </div>
            <div className="empty-state">
              <div className="empty-illustration">
                <FaRegFileAlt className="empty-file" />
                <FaSearch className="empty-search" />
              </div>
              <span>No records</span>
            </div>
          </section>
        </main>

        <footer className="footer">
          {footerGroups.map((group) => (
            <div className="footer-group" key={group.title}>
              <h2>{group.title}</h2>
              {group.social ? (
                <div className="social-grid">
                  {group.links.map(({ label, icon: SocialIcon }) => (
                    <span key={label} title={label}>
                      <SocialIcon />
                    </span>
                  ))}
                </div>
              ) : (
                group.links.map((link) => (
                  <a href="#top" key={link}>
                    {link}
                  </a>
                ))
              )}
            </div>
          ))}
        </footer>
      </div>

      {showEditor ? (
        <EditPanel
          values={values}
          onChange={updateValue}
          onHide={() => setShowEditor(false)}
        />
      ) : (
        <button
          className="show-editor"
          type="button"
          onClick={() => setShowEditor(true)}
        >
          Edit
        </button>
      )}

      <button className="help-button" aria-label="Support" type="button">
        <MdHeadsetMic />
      </button>
    </div>
  );
}

export default App;
